// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.nav-tabs .nav-link.active,
.nav-tabs .nav-item.show .nav-link {
  color: white;
  background-color: transparent;
  border: none;
  text-decoration: underline;
  text-decoration-color: #ad8bff;
  text-decoration-thickness: 2px;
  text-underline-offset: 5px;
  /* border-bottom: 3px solid #fff;
    display: inline-block;
    padding-bottom: 1px; */
}
.chart-suss{
  font-size: 12px;
}
.value-sus{
  font-size:12px;
}
.nav-tabs {
  border-bottom: none;
  margin-left: 10px;
}
.subheading{
  color: yellow;
  font-size: 12px;
}
.nav-link, .nav-link:hover {
  color: white;
}

.report-sub-container-1 {
  padding: 1%;
  
  margin: 2%  2% 0;
}

.report-sub-container-2 {
  background-color: rgba(33, 72, 131, 0.5);
  border-radius: 5px;
  padding: 2%;
}
.report-sub-container-3 {
  border-radius: 0rem 0rem 1.25rem 1.25rem;
  border: 1px solid #747ba9;
  background: rgba(255, 255, 255, 0.05);
  overflow-y:scroll;
  height: 500px;
  padding: 2%;
}
.container-3-title {
  padding: 1% 1% 4% 1%;
  font-size:13px;
}
.title{
  font-size: 14px;
}
.scroll-overflow-container {
  max-height: 500px;
  overflow-y: scroll;
  overflow-x: hidden;
}
.scroll-overflow-container1 {
  max-height: 200px;
  overflow-y: scroll;
  width:1050px;
  margin-top: 30px;
  overflow-x: hidden;
}
.overflow-container-box {
  background-color: #3c4069;
  border-radius: 0.625rem;
  border: 1px solid #747ba9;
  margin: 0 2% 2% 0%;
  padding-top: 1%;
}
.number-style {
  color: white;
  font-size: 1vw;
  font-weight: bold;
  border: 1px solid white;
  background-color: #747ba9;
  padding: 6px 19px 6px 11px;
  border-radius: 50%;
}
.overflow-container-title {
  color: #3bbc6f;
  font-weight: bold;
  font-size: 14px;
}
`, "",{"version":3,"sources":["webpack://./src/Sustainability/SustainabilityReport.css"],"names":[],"mappings":"AAAA;;EAEE,YAAY;EACZ,6BAA6B;EAC7B,YAAY;EACZ,0BAA0B;EAC1B,8BAA8B;EAC9B,8BAA8B;EAC9B,0BAA0B;EAC1B;;0BAEwB;AAC1B;AACA;EACE,eAAe;AACjB;AACA;EACE,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,eAAe;AACjB;AACA;EACE,YAAY;AACd;;AAEA;EACE,WAAW;;EAEX,gBAAgB;AAClB;;AAEA;EACE,wCAAwC;EACxC,kBAAkB;EAClB,WAAW;AACb;AACA;EACE,wCAAwC;EACxC,yBAAyB;EACzB,qCAAqC;EACrC,iBAAiB;EACjB,aAAa;EACb,WAAW;AACb;AACA;EACE,oBAAoB;EACpB,cAAc;AAChB;AACA;EACE,eAAe;AACjB;AACA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,yBAAyB;EACzB,uBAAuB;EACvB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,YAAY;EACZ,cAAc;EACd,iBAAiB;EACjB,uBAAuB;EACvB,yBAAyB;EACzB,0BAA0B;EAC1B,kBAAkB;AACpB;AACA;EACE,cAAc;EACd,iBAAiB;EACjB,eAAe;AACjB","sourcesContent":[".nav-tabs .nav-link.active,\n.nav-tabs .nav-item.show .nav-link {\n  color: white;\n  background-color: transparent;\n  border: none;\n  text-decoration: underline;\n  text-decoration-color: #ad8bff;\n  text-decoration-thickness: 2px;\n  text-underline-offset: 5px;\n  /* border-bottom: 3px solid #fff;\n    display: inline-block;\n    padding-bottom: 1px; */\n}\n.chart-suss{\n  font-size: 12px;\n}\n.value-sus{\n  font-size:12px;\n}\n.nav-tabs {\n  border-bottom: none;\n  margin-left: 10px;\n}\n.subheading{\n  color: yellow;\n  font-size: 12px;\n}\n.nav-link, .nav-link:hover {\n  color: white;\n}\n\n.report-sub-container-1 {\n  padding: 1%;\n  \n  margin: 2%  2% 0;\n}\n\n.report-sub-container-2 {\n  background-color: rgba(33, 72, 131, 0.5);\n  border-radius: 5px;\n  padding: 2%;\n}\n.report-sub-container-3 {\n  border-radius: 0rem 0rem 1.25rem 1.25rem;\n  border: 1px solid #747ba9;\n  background: rgba(255, 255, 255, 0.05);\n  overflow-y:scroll;\n  height: 500px;\n  padding: 2%;\n}\n.container-3-title {\n  padding: 1% 1% 4% 1%;\n  font-size:13px;\n}\n.title{\n  font-size: 14px;\n}\n.scroll-overflow-container {\n  max-height: 500px;\n  overflow-y: scroll;\n  overflow-x: hidden;\n}\n.scroll-overflow-container1 {\n  max-height: 200px;\n  overflow-y: scroll;\n  width:1050px;\n  margin-top: 30px;\n  overflow-x: hidden;\n}\n.overflow-container-box {\n  background-color: #3c4069;\n  border-radius: 0.625rem;\n  border: 1px solid #747ba9;\n  margin: 0 2% 2% 0%;\n  padding-top: 1%;\n}\n.number-style {\n  color: white;\n  font-size: 1vw;\n  font-weight: bold;\n  border: 1px solid white;\n  background-color: #747ba9;\n  padding: 6px 19px 6px 11px;\n  border-radius: 50%;\n}\n.overflow-container-title {\n  color: #3bbc6f;\n  font-weight: bold;\n  font-size: 14px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
